import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { Item, Description, ItemBold, Wrapper } from './OrderDescription.styles';
import { IOrderDescription } from './OrderDescription.types';

function OrderDescription(props: IOrderDescription): ReactElement {
  const { shopName, description, buyerEmail, elementRef, descriptionElementRef } = props;
  return (
    <Wrapper ref={elementRef}>
      <Item>
        <FormattedMessage id="statusBar.sellerText" />
      </Item>
      <ItemBold data-testid="statusbar-mobile:description-shop-name">{shopName}</ItemBold>
      <Description>
        <FormattedMessage id="statusBar.orderDescription" />
        <p
          ref={descriptionElementRef}
          className="statusbar-mobile__description"
          data-testid="statusbar-mobile:description"
        >
          {description}
        </p>
      </Description>
      <Item>
        <FormattedMessage id="statusBar.buyerText" />
      </Item>
      <ItemBold data-testid="statusbar-mobile:buyer-text">{buyerEmail}</ItemBold>
    </Wrapper>
  );
}

export default OrderDescription;
